import {confettiOnMouseEvent, confettiBelowModal} from '../../../lib/confetti'

const BUTTON_CLICK_EVENT = 'user.profile.loyalty.claim-reward'
const CLAIM_INIT_EVENT = 'user.profile.loyalty.claim-init'
const REWARD_CONFIRMATION_EVENT = 'user.profile.loyalty.reward.confirm'

export default (Bus) => {
  Bus.$on(BUTTON_CLICK_EVENT, async ($event, mouseEvent, vm) => {
    confettiOnMouseEvent(mouseEvent)
  })

  confettiBelowModal(Bus, REWARD_CONFIRMATION_EVENT)
}
